<template>
	<el-container class='container' v-if='token'>
		<aside-bar></aside-bar>
		<el-container class='is-vertical page'>
			<header-bar></header-bar>
			<page></page>
		</el-container>
		<big-pic></big-pic>
	</el-container>
</template>

<script scoped>
	import AsideBar from '@/views/layout/components/Aside'
	import HeaderBar from '@/views/layout/components/Header'
	import Page from '@/views/layout/components/Page'
	import bigPic from '@/views/layout/components/bigPic'
	import { getToken } from '@/utils/auth'

	export default {
		name: 'layout',
		components: {
			AsideBar,
			HeaderBar,
			Page,
			bigPic
		},

		mounted: function () {
			this.isEnter()
		},

	    data () {
	    	return {
	    		token: null
	    	}
	    },

	    methods: {
			isEnter () {
			  	this.token = getToken();
	    		// 去登录
	    		if(!this.token){
			  		this.$router.push({
			  			path: '/login'
			  		});
					return
	    		}
			  	// 直接登录
				var hash = window.location.hash.substring(1);
				this.$router.push({
					path: hash
				});
			},

	    }
	};
</script>

<style type="text/less" lang="less" scoped>
	.container{
		height: 100vh;
	}
	.page{
		min-width: 900px;
		overflow-x: auto;
	}
</style>


// WEBPACK FOOTER //
// src/views/layout/index.vue